import React, {useState} from 'react';
import Typography from '@mui/material/Typography';
import {IconButton, Snackbar, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import EmailIcon from '@mui/icons-material/Email';
import styles from './ContactSection.module.scss';
import Section from "./Section";
import {stCONTACT} from "./NavBar";


const ContactSection: React.FC = () => {

    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const sendEmail = async () => {
        const response = await fetch('/api/send-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({name, email, message}),
        });

        if (response.ok) {
            setSnackbarMessage('Email sent successfully!');
        } else {
            setSnackbarMessage('Failed to send email.');
        }
    };

    const handleClose = () => {
        setSnackbarMessage('');
    };

    return (
        <Section className={styles.getInTouch} id={stCONTACT}>
            <Typography variant="h4" component="h1">Get in touch</Typography>
            <IconButton
                color="primary"
                href={`mailto:marc@equiscrib.com?subject=Contact%20Request&body=Name:%20${name}%0AEmail:%20${email}%0AMessage:%20${message}`}
            >
                <EmailIcon />
            </IconButton>
            <TextField label="Name" variant="outlined" fullWidth margin="normal"
                       slotProps={{htmlInput: {maxLength: 50}}}
                       required
                       onChange={(e) => setName(e.target.value)}
            />
            <TextField label="Email" variant="outlined" fullWidth margin="normal"
                       slotProps={{htmlInput: {maxLength: 255}}}
                       required
                       onChange={(e) => setEmail(e.target.value)}
            />
            <TextField label="Message" variant="outlined" fullWidth margin="normal" multiline rows={10}
                       slotProps={{htmlInput: {maxLength: 2000}}}
                       required
                       onChange={(e) => setMessage(e.target.value)}
            />
            <Button variant="contained" color="primary" onClick={() => sendEmail()}>Send</Button>
            <Snackbar
                open={!!snackbarMessage}
                autoHideDuration={4000}
                onClose={handleClose}
                message={snackbarMessage}
            />
        </Section>
    )
}

export default ContactSection;